var map = {
	"./0.png": 408652,
	"./1.png": 320277,
	"./2.png": 483550,
	"./3.png": 175687,
	"./4.png": 596072,
	"./5.png": 528113,
	"./6.png": 868218,
	"./7.png": 458051,
	"./8.png": 457860,
	"./9.png": 121101,
	"./x.png": 184708
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 984495;